<template>
	<v-dialog v-model="dialog" max-width="800px" scrollable persistent>
		<v-card>
			<v-img :src="currentFeature.img" gradient="to top right, rgb(255,255,255,.2), rgb(118,118,118,.3)">
				<v-card-title class="white--text font-weight-bold mb-3">
					<v-spacer />
					<v-btn icon dark @click="dismiss">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-subtitle v-if="currentFeature.title" class="pb-0 white--text font-weight-bold text-h6">{{ currentFeature.title }}</v-card-subtitle>
				<v-card-text v-if="currentFeature.description" class="pa-2 pr-1">{{ currentFeature.description }}</v-card-text>
			</v-img>
		</v-card>
	</v-dialog>
</template>

<script>
import { get } from 'axios';
import moment from 'moment';
import { endpoint, FEATURE_CONFIG_ENDPOINT, APP_BASE_URL } from '@/utils/api/endpoints';

export default {
	data() {
		return {
			dialog: false,
			currentFeature: {
				img: '',
				title: '',
				description: '',
			},
		};
	},

	methods: {
		open() {
			this.loadFeatures();
			this.dialog = true;
		},

		close() {
			this.dialog = false;
		},

		dismiss() {
			localStorage.setItem('featureViewedDate', moment().format('YYYY-MM-DD'));
			this.close();
		},

		async loadFeatures() {
			const url = endpoint(APP_BASE_URL, FEATURE_CONFIG_ENDPOINT);
			const { data } = await get(url);
			const feature = data.find(x => x.active);
			if (feature) this.currentFeature = feature;
			return feature;
		},
	},
};
</script>

<style scoped>
#transaction-dialog-content {
	max-height: 250px;
	overflow-y: auto;
}

.wallet-reference-label {
	line-height: 0.5rem;
}
</style>
